import React, { useState } from 'react'

import ButtonComponentsUi from '../../components/button/ButtonComponentsUi'
import { ButtonGroup } from '@mui/material'
import ProductionPurchaseListController from '../Production/ProductionPurchaseListController'
import PurchaseRequestListController from './PurchaseRequestListController'

const PurchaseRequestMainUi = () => {
    const [buttonStatus, setButtonStatus] = useState("Material_Request")

  return (
    <>
        <ButtonGroup >
            <ButtonComponentsUi
                onSubmit={() => setButtonStatus("Material_Request")}
                ButtonGroup
                STATUSWiseData={buttonStatus === "Material_Request"}
                Title={"Material Request"}
            />
            <ButtonComponentsUi
                onSubmit={() => setButtonStatus("Production_Purchase")}
                ButtonGroup
                STATUSWiseData={buttonStatus === "Production_Purchase"}
                Title={"Production Purchase Request"}
            />
        </ButtonGroup>
        {buttonStatus === "Material_Request" && <PurchaseRequestListController/>}
        {buttonStatus === "Production_Purchase" && <ProductionPurchaseListController />}
        </>
  )
}

export default PurchaseRequestMainUi